// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"da88ce33","817":"7dc8f293"}[chunkId] + ".chunk.js";
};